import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { adverseMediaListQueryOptions } from '~bank-adverse-media/service/adverseMediaListQueryOptions'
import { adverseMediaListSchema } from '~bank-adverse-media/types/AdverseMediaListRequest'

export const listRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '/',
    validateSearch: (search) => adverseMediaListSchema.parse(search),
    loaderDeps: (all) => ({
      search: all.search
    }),
    loader: ({ cause, deps, context }) => {
      if (cause === 'stay') {
        return null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(adverseMediaListQueryOptions(deps.search))
    },
    component: lazyRouteComponent(() => import('./List'))
  })
